const InsuranceDecorator = require('./insurances.decorator');
const ServiceOptionsDecorator = require('./service.options.decorator');
const FareRuleDecorator = require('./fare.rules.decorator');
const BagDecorator = require('./bags.decorator');
const SeatDecorator = require('./seats.decorator');
const BoardingOptionDecorator = require('./boarding.options.decorator');
const FastTrackDecorator = require('./fast.track.decorator');

module.exports = {
    nameCreator: {
        INSURANCE: (data = {}) => InsuranceDecorator.getProductName(data),
        SERVICE_OPTION: (data = {}) => ServiceOptionsDecorator.getProductName(data),
        FARE_RULE: (data = {}) => FareRuleDecorator.getProductName(data),
        SEATS: () => SeatDecorator.getProductName(),
        BOARDING_OPTIONS: () => BoardingOptionDecorator.getProductName(),
        BAGGAGE: (data = {}) => BagDecorator.getProductName(data),
        FAST_TRACK: (data = {}) => FastTrackDecorator.getProductName(data),
    },
    isCommittableByDefault: {
        INSURANCE: true,
        SERVICE_OPTION: true,
        FARE_RULE: true,
        SEATS: false,
        BOARDING_OPTIONS: false,
        BAGGAGE: false,
        FAST_TRACK: false,
    },
    dataDecorator: {
        INSURANCE: (data = {}) => InsuranceDecorator.decorate(data),
        SERVICE_OPTION: (data = {}) => ServiceOptionsDecorator.decorate(data),
        FARE_RULE: (data = {}) => FareRuleDecorator.decorate(data),
        SEATS: (data = {}) => SeatDecorator.decorate(data),
        BOARDING_OPTIONS: (data = {}) => BoardingOptionDecorator.decorate(data),
        BAGGAGE: (data = {}) => BagDecorator.decorate(data),
        FAST_TRACK: (data = {}) => FastTrackDecorator.decorate(data),
    },
    processIds: {
        INSURANCE: (ids = []) => InsuranceDecorator.processIds(ids),
        SERVICE_OPTION: (ids = []) => ServiceOptionsDecorator.processIds(ids),
        FARE_RULE: (ids = []) => FareRuleDecorator.processIds(ids),
        SEATS: (ids = []) => SeatDecorator.processIds(ids),
        BOARDING_OPTIONS: (ids = []) => BoardingOptionDecorator.processIds(ids),
        BAGGAGE: (ids = []) => BagDecorator.processIds(ids),
        FAST_TRACK: (ids = {}) => FastTrackDecorator.processIds(ids),
    },
};
